import { v4 as uuid } from 'uuid';

import { ActionId } from 'client/app/apps/disco-prototype/state/actions/actions';
import {
  applyValueUpdate,
  Value,
  ValueUpdate,
} from 'client/app/apps/disco-prototype/state/table';
import { Error } from 'common/types/disco/calculateVolumes';

export type IncubateAction = {
  id: ActionId;
  type: 'incubate';
  title: string;
  duration: Value;
  temperature: Value;
  compiled?: {
    errors?: Error[];
  };
};

export const getDefaultIncubateAction = (): IncubateAction => ({
  id: uuid(),
  type: 'incubate',
  title: 'Incubate',
  duration: { selectedMode: 'const', value: '10s' },
  temperature: { selectedMode: 'const', value: '21ºC' },
});

export type IncubateActionUpdate = {
  toUpdate: ActionId;
  type: 'incubate';
  title?: string;
  duration?: ValueUpdate;
  temperature?: ValueUpdate;
};

export const applyIncubateActionUpdate = (
  action: IncubateAction,
  update?: IncubateActionUpdate,
) => {
  if (!update) return;

  action.title = update.title ?? action.title;
  applyValueUpdate(action.duration, update.duration);
  applyValueUpdate(action.temperature, update.temperature);
};
